import Vue from 'vue';

const vm = new Vue({
  methods: {
    success(text) {
      this.$snack.success(
        text,
      )
    },
    error(text) {
      this.$snack.error(
        text,
      )
    },
    warning(text) {
      this.$snack.warning(
        text,
      )
    }
  }
});

export const $snack = vm


